import { useEmailEditor } from 'features/EmailEditor/EmailEditorContext'
import EmailEditorPanel from 'features/EmailEditor/EmailEditorPanel'
import campaignEditorStyles from 'features/ManageCampaigns/EditTextDialog.module.scss'
import { useEffect } from 'react'

const CampaignEmailCustomizationSection = ({
  includeInboxFields = true,
  className
}) => {
  const { setEditingSection } = useEmailEditor()

  useEffect(() => {
    setEditingSection(null)
  }, [setEditingSection])

  return (
    <div className={className || campaignEditorStyles.emailEditorPanelHolder}>
      <EmailEditorPanel
        campaignBodyOnly
        includeInboxFields={includeInboxFields}
        hideFooter
        compact={Boolean(className)}
      />
    </div>
  )
}

export default CampaignEmailCustomizationSection
